export default class ClienteTelefone {
  constructor(
    id_cliente = null,
    id_cliente_telefone = null,
    tipo_telefone = 'GERAL',
    telefone = '',
    contato = '',
    versao_imp = 0
  ) {
    this.id_cliente = id_cliente;
    this.id_cliente_telefone = id_cliente_telefone;
    this.tipo_telefone = tipo_telefone;
    this.telefone = telefone;
    this.contato = contato;
    this.versao_imp = versao_imp;
  }
}